import React, {useEffect, useState} from "react";
import {Col} from "react-bootstrap";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import VideoModal from "../../../components/VideoModal";
import Table from "../../../components/Table/Table";
import DefaultModal from "../../invoice/DefaultModal";
import Form from "react-bootstrap/Form";
import FormGroup from "react-bootstrap/FormGroup";
import {Button, Input, Label} from "reactstrap";
import NavBarKS from "../../../components/NavBarKS";
import StickButton from "../../../components/StickButton";
import Alert from "react-s-alert";

const CustomerComment = (props) => {
    const {currentUser, type} = props;
    const [content, setContent] = useState([]);
    const [contentCustomer, setContentCustomer] = useState([])
    const [loading, setLoading] = useState(false);
    const [size, setSize] = useState(10);
    const [customerSize, setCustomerSize] = useState(4)
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(null);
    const [video, setVideo] = useState(null);
    const [videoModal, setVideoModal] = useState(false);
    const [createEditModal, setCreateEditModal] = useState(false);
    const [imageSet, setImageSet] = useState(false);
    const [editData, setEditData] = useState({
        recordId: null,
        customerName: null,
        customerLastname: null,
        customerTitle: null,
        comment: null,
        image: null,
        videoUrl: null
    });
    const [customerData, setCustomerData] = useState([]);

    const switchVideo = (e, videos) => {
        setVideo({
            title: "Müşterilerimizin Gözünde Biz!",
            id: videos
        })
        setVideoModal(true);
        window.removeEventListener('resize', updateDimensions);
    };

    const onChangeImage = (image) => {
        const file = image.target.files[0];
        let reader = new FileReader();
        reader.onloadend = (e) => {
            const imageBase64 = e.target.result;
            handleInputChange("image", imageBase64)
            setImageSet(true)
        }
        reader.readAsDataURL(file);
    }

    const closeVideoModal = () => {
        setVideoModal(false);
    }

    const updateDimensions = (event) => {
        let currentHeight = window.innerHeight;
        let currentWidth = window.innerWidth;
    }

    const handleEdit = (row) => {
        setEditData(row);
        setCreateEditModal(true);
    }

    const validateData = () => {
        let valid = true;
        let message = "";

        if (editData["customerName"] === null) {
            message = message + `Müşteri adı boş olamaz.</br>`;
            valid = false;
        }
        if (editData["customerLastname"] === null) {
            message = message + `Müşteri soyadı boş olamaz.</br>`;
            valid = false;
        }
        if (editData["customerTitle"] === null) {
            message = message + `Müşteri başlığı boş olamaz.</br>`;
            valid = false;
        }
        if (editData["image"] === null) {
            message = message + `Resim boş olamaz.</br>`;
            valid = false;
        }
        if (editData["videoUrl"] === null) {
            message = message + `Video url boş olamaz.</br>`;
            valid = false;
        }
        return {valid: valid, message: message}
    }

    const handleDelete = (row) => {
        let params = {
            url: `/customerComment/deleteById/${row.recordId}`,
            method: "get"
        }
        request(params).then((response) => {
            Alert.success("Silme işlemi başarılı.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            })
            fetchData(0);
        }).catch((err) => {
            showAxiosError(err);
        })
    }

    const handleInputChange = (name, value) => {
        editData[name] = value;
        setEditData(editData);
    }

    const save = (comment) => {
        let result = validateData();

        let params = {
            url: '/customerComment/createUpdate',
            method: "post",
            data: editData
        }

        if (result.valid) {
            request(params).then((response) => {

                Alert.success("Kaydetme işlemi başarılı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                })

                setCreateEditModal(false);
                setEditData({
                    recordId: null,
                    customerName: null,
                    customerLastname: null,
                    customerTitle: null,
                    comment: null,
                    image: null,
                    videoUrl: null
                });
                fetchData(0);
                setImageSet(false)
            }).catch((err) => {
                showAxiosError(err);
                setLoading(false);
            })
        } else {
            Alert.error(result.message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000,
                html: true
            });
        }
    }

    const onCancel = () => {
        setCreateEditModal(false);
        setEditData({
            recordId: null,
            customerName: null,
            customerLastname: null,
            customerTitle: null,
            comment: null,
            image: null,
            videoUrl: null
        });
        setImageSet(false);
    }

    const fetchData = (accessor, direction, page, size) => {

        let params = {
            url: '/customerComment/getPage?page=' + page + '&size=' + (type === 'Customer' ? customerSize : size),
            method: "post"
        }

        setLoading(true);
        request(params).then((response) => {
            setPage(page)
            setTotal(response.data.totalElements)
            setContent(response.data.content);
            setLoading(false);
        }).catch((err) => {
            showAxiosError(err);
            setLoading(false);
        })
    }

    useEffect(() => {
        if (type === "Customer") {
            let page = 0;
            let params = {
                url: '/customerComment/getPage?page=' + page + '&size=' + customerSize,
                method: "post"
            }

            setLoading(true);
            request(params).then((response) => {
                setContentCustomer(response.data.content);
                setLoading(false);
                setPage(page)
            }).catch((err) => {
                showAxiosError(err);
                setLoading(false);
            })
        }
    }, [type])

    const addPage = () => {

        let params = {
            url: '/customerComment/getPage?page=' + (page + 1) + '&size=' + customerSize,
            method: "post"
        }
        setLoading(true);
        request(params).then((response) => {
            setTotal(response.data.totalElements)
            setPage(page + 1)
            setCustomerData(response.data.content);
            setLoading(false);
        }).catch((err) => {
            showAxiosError(err);
            setLoading(false);
        })
    }

    useEffect(() => {
        contentCustomer.push(...customerData)
    }, [customerData])

    const columns = [
        {
            Header: "Müşteri Adı",
            accessor: "",
            sortable: false,
            Cell: row => (
                <label>{row.customerName}</label>
            )
        },
        {
            Header: "Müşteri Soyadı",
            accessor: "",
            sortable: false,
            Cell: row => (
                <label>{row.customerLastname}</label>
            )
        },
        {
            Header: "Müşteri Başlığı",
            accessor: "",
            sortable: false,
            Cell: row => (
                <label>{row.customerTitle}</label>
            )
        },
        {
            Header: "Video Id",
            accessor: "",
            sortable: false,
            Cell: row => (
                <label>{row.videoUrl}</label>
            )
        },
        {
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            width: "11%",
            Cell: row => (
                <div className="btn-group">
                    <div className="dropdown">
                        <button className="MenuBtn2 listt btn btn-default" type="button" data-toggle="dropdown">Seçİnİz
                        </button>
                        <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>
                            <a className="dropdown-item" onClick={() => handleEdit(row)}>
                                <i className="fa fa-edit"/> Müşteri Yorumunu Düzenle
                            </a>
                            <a className="dropdown-item" onClick={() => handleDelete(row)}>
                                <i className="fa fa-edit"/> Müşteri Yorumunu Sil
                            </a>
                        </div>
                    </div>
                </div>
            )
        }
    ]

    return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={props.offsetWidth} innerWidth={window.innerWidth} name='customerCommentList'>
                    {type !== 'Customer' &&
                        <StickButton position="leftSide"
                                     onClick={() => setCreateEditModal(true)}
                                     label="Yeni Oluştur"
                                     title="Yeni Oluştur"
                                     className="stickButton plus-circle"
                                     icon="plus-circle"/>
                    }
                </NavBarKS>
                <div className="col-sm-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">Müşterilerimizin Gözünde Biz !</h4>
                    </div>
                    {type === 'Customer' &&
                        contentCustomer.map((row, i) => (
                            <div className="card mb-3"
                                 style={{maxWidth: '540px', height: '300px', marginRight: '20px'}}>
                                <div className="row g-0">
                                    <div className="col-md-12">
                                        <a key={i} className="dropdown-item" style={{background: 'none'}}
                                           onClick={(e) => switchVideo(e, row.videoUrl)}>
                                            <img src={row.image}
                                                 className="img-fluid rounded-start"
                                                 alt="Base64 Image" style={{height: '295px', width: '100%'}}/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {type === "Customer" &&
                        <div style={{textAlign: 'center'}}>
                            <Button onClick={addPage}>Daha Fazla Göster...</Button>
                        </div>
                    }
                    {videoModal && type === "Customer" &&
                        <VideoModal video={video} isOpen={videoModal} close={closeVideoModal}/>
                    }
                    {type === "CallCenter" &&
                        <Table columns={columns}
                               loading={loading}
                               loadingText="Kayıtlar getiriliyor..."
                               content={content}
                               total={total}
                               page={page}
                               size={size}
                               options={["5", "10", "20", "50", "100"]}
                               fetchData={fetchData}
                        />
                    }
                    {type === "CallCenter" && createEditModal &&
                        <DefaultModal
                            isOpen={createEditModal}
                            title={"Müşteri Yorumu"}
                            confirmBtnText="Gönder"
                            size={"l"}
                            cancelBtnText="İptal"
                            onConfirm={(e) => save(e)}
                            onCancel={onCancel}
                        >
                            <Form className="px4">
                                <FormGroup row>
                                    <Label sm={4}>Müşteri Adı *</Label>
                                    <Col sm={8}>
                                        <Input type="text" name="customerName" id="customerName"
                                               onChange={(e) => handleInputChange("customerName", e.target.value)}
                                               defaultValue={editData && editData.customerName ? editData.customerName : ''}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={4}>Müşteri Soyadı *</Label>
                                    <Col sm={8}>
                                        <Input type="text" name="customerLastname" id="customerLastname"
                                               onChange={(e) => handleInputChange("customerLastname", e.target.value)}
                                               defaultValue={editData && editData.customerLastname ? editData.customerLastname : ''}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={4}>Müşteri Başlığı *</Label>
                                    <Col sm={8}>
                                        <Input type="text" name="customerTitle" id="customerTitle"
                                               onChange={(e) => handleInputChange("customerTitle", e.target.value)}
                                               defaultValue={editData && editData.customerTitle ? editData.customerTitle : ''}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={4}>Video Id *</Label>
                                    <Col sm={8}>
                                        <Input type="text" name="videoUrl" id="videoUrl"
                                               onChange={(e) => handleInputChange("videoUrl", e.target.value)}
                                               defaultValue={editData && editData.videoUrl ? editData.videoUrl : ''}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label sm={4}>Resim *</Label>
                                    <Col sm={8}>
                                        <Button className="text-white bg-warning" size="sm">
                                            <i className="fas fa-plus" style={{fontSize: "x-large"}}/>
                                            <Input type="file" name="image" accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG"
                                                   onChange={onChangeImage}/>
                                        </Button>
                                        {imageSet &&
                                            <label sm={4}>Resim Eklendi.</label>
                                        }
                                    </Col>
                                </FormGroup>
                            </Form>
                        </DefaultModal>
                    }
                </div>
            </div>
    )
}
export default CustomerComment;